import React from "react";
import { useEffect, useState } from "react";
import { useAxios } from "../../../hooks/useAxios";
import { useTranslation } from "react-i18next";

const Libros = () => {
    const [t, i18n] = useTranslation("home");
    const [g] = useTranslation("global");
    const liga_lang2 = "/" + i18n.language + "/LibroSociedades";
    const liga_lang3 = "/" + i18n.language + "/LibroLibertad";
    const liga_lang4 = "/" + i18n.language + "/LibroNegocios";
    const liga_lang5 = "/" + i18n.language + "/LibroBitcoin";

    const { data, isloading, error } = useAxios(
        `/library/nbooks2?offset=0&next=9&sitioid=2&lenguaje=${i18n.language}`
    );
    const liga_lang1 = "/" + i18n.language + "/biblioteca";
    const [books, setBooks] = useState(null);

    const trackAnalyticsClick = (label) => {
        window.gtag('event', 'click', {
            event_category: 'Sobre Mi',
            event_label: label,
            value: 1
        });
    };

    useEffect(() => {
        if (data) {
            setBooks(data);
        }
    }, [data]);

    const [im] = useTranslation("libroBitcoin");
    const bannerImageBlanco =
        im("donde.btnaudio") === "ES"
            ? "/assets/img2026/book_cover_4.png"
            : "/assets/img2026/book_cover_4_en.png";
    const bannerImageBitcoin =
        im("donde.btnaudio") === "ES"
            ? "/assets/img2026/book_cover_0.png"
            : "/assets/img2026/bitcoin_englightment.png";

    return (
        <div className="_ngcontent-ng-c3910305518">
            <section _ngcontent-ng-c4217852871="" aria-labelledby="about-books-title" class="about-books">
                <div _ngcontent-ng-c4217852871="" class="about-books__content">
                    <h2 _ngcontent-ng-c4217852871="" id="about-books-title" class="about-books__title">{t("2026.leyenda-sobremi")}
                    </h2>
                    {/*<nav _ngcontent-ng-c4217852871="" aria-label="Categorias de libros" class="about-books__tabs">
                        <button
                            _ngcontent-ng-c4217852871="" type="button" class="about-books__tab about-books__tab--active"> {t("2026.leyenda-btn")} </button>
                        <button _ngcontent-ng-c4217852871="" type="button" class="about-books__tab">
                            {t("2026.leyenda-btn2")} </button>
                    </nav>*/}
                </div>
                <div _ngcontent-ng-c4217852871="" class="about-books__rail">
                    <div _ngcontent-ng-c4217852871="" aria-label="Recomendaciones de libros" class="about-books__grid">
                        <article _ngcontent-ng-c4217852871="" class="about-books__card"><img _ngcontent-ng-c4217852871=""
                            loading="lazy" class="about-books__card-image" src={bannerImageBitcoin}
                            alt="La iluminación de bitcoin" />
                            
                            <h3 _ngcontent-ng-c4217852871="" class="about-books__card-title">{t("2026.libro1")}<br/><p _ngcontent-ng-c4217852871="" class="about-books__card-author autor-solo-desk">Ricardo Salinas</p></h3>
                            <p _ngcontent-ng-c4217852871="" class="about-books__card-author autor-solo-mov">Ricardo Salinas</p>
                            <a onClick={() => trackAnalyticsClick('Sobre mi - Libro: Bitcoin')}
                                _ngcontent-ng-c4217852871="" class="about-books__card-link"
                                href={liga_lang5}>{t("2026.bookmore")}</a>
                        </article>
                        <article _ngcontent-ng-c4217852871="" class="about-books__card"><img _ngcontent-ng-c4217852871=""
                            loading="lazy" class="about-books__card-image" src="/assets/img2026/book_cover_1.png"
                            alt="Ideas que transforman negocios para cambiar al mundo" />
                            <h3 _ngcontent-ng-c4217852871="" class="about-books__card-title">{t("2026.libro2")}<br/><p _ngcontent-ng-c4217852871="" class="about-books__card-author autor-solo-desk">Ricardo Salinas</p></h3>
                            <p _ngcontent-ng-c4217852871="" class="about-books__card-author autor-solo-mov">Ricardo Salinas</p>
                            <a onClick={() => trackAnalyticsClick('Sobre mi - Libro: Azul')} _ngcontent-ng-c4217852871="" class="about-books__card-link"
                                href={liga_lang4}>{t("2026.bookmore")}</a>
                        </article>
                        <article _ngcontent-ng-c4217852871="" class="about-books__card"><img _ngcontent-ng-c4217852871=""
                            loading="lazy" class="about-books__card-image" src="/assets/img2026/book_cover_2.png"
                            alt="Ideas que transforman sociedades para cambiar al mundo" />

                            <h3 _ngcontent-ng-c4217852871="" class="about-books__card-title">{t("2026.libro3")}<br/><p _ngcontent-ng-c4217852871="" class="about-books__card-author autor-solo-desk">Ricardo Salinas</p></h3>
                            <p _ngcontent-ng-c4217852871="" class="about-books__card-author autor-solo-mov">Ricardo Salinas</p>
                            <a onClick={() => trackAnalyticsClick('Sobre mi - Libro: Verde')} _ngcontent-ng-c4217852871="" class="about-books__card-link"
                                href={liga_lang2}>{t("2026.bookmore")}</a>
                        </article>
                        <article _ngcontent-ng-c4217852871="" class="about-books__card"><img _ngcontent-ng-c4217852871=""
                            loading="lazy" class="about-books__card-image" src={bannerImageBlanco}
                            alt="Ideas sobre la libertad que cambian el mundo" />

                            <h3 _ngcontent-ng-c4217852871="" class="about-books__card-title">{t("2026.libro4")}<br/><p _ngcontent-ng-c4217852871="" class="about-books__card-author autor-solo-desk">Ricardo Salinas</p></h3>
                            <p _ngcontent-ng-c4217852871="" class="about-books__card-author autor-solo-mov">Ricardo Salinas</p>
                            <a onClick={() => trackAnalyticsClick('Sobre mi - Libro: Blanco')} _ngcontent-ng-c4217852871="" class="about-books__card-link"
                                href={liga_lang3}>{t("2026.bookmore")}</a>
                        </article>
                    </div>
                </div>
                <div _ngcontent-ng-c4217852871="" class="about-books__content"><a onClick={() => trackAnalyticsClick('Sobre mi - Mas libros')} _ngcontent-ng-c4217852871=""
                    class="about-books__mobile-link" href={"/" + i18n.language + "/biblioteca"}>{t("2026.recomendaciones-btn")}</a></div>
            </section>
        </div>
    );
};

export default Libros;